<template lang="html">
  <div class="card animated fadeIn">
    <div style="padding: 15px;">
      <div style="margin: 10px 0 0 0px; display: flex;">
        <h4 style="color: #6E6E6E">Cancelamentos do pedido</h4>
        <h4 style="color: #313a70; font-weight: bold; margin-left: 5px;">#{{ cancellations.reference }}</h4>
      </div>
      <div>
        <table>
          <tbody>
            <tr>
              <td style="width: 200px;">
                <div style="color: #6E6E6E">
                  <div>
                    <strong>CCB n. {{ cancellations.ccbNumber }}</strong>
                  </div>
                  <div>
                    {{ cancellations.dateCreated | moment }}
                    {{ cancellations.dateCreated | moment-hour }}
                  </div>
                </div>
              </td>
              <td style="width: 250px;">
                <div style="color: #6E6E6E">
                  <div>
                    <strong>{{ cancellations.buyerName }}</strong>
                  </div>
                  <div>
                    {{ cancellations.amount | numeral("$ 0,0.00") }}
                  </div>
                </div>
              </td>
              <td style="width: 250px; display: flex;">
                <img
                  height="50"
                  :src="
                    '/static/sellers/' +
                      cancellations.sellerName[0].toUpperCase() +
                      cancellations.sellerName
                        .toLowerCase()
                        .replace(/ /g, '_')
                        .slice(1) +
                      '.png'
                  "
                  class="img-profile"
                />
                <div style="color: #6E6E6E; margin-left: 10px;">
                  <div>
                    <strong>{{ cancellations.sellerName }}</strong>
                  </div>
                  <div>
                    {{ cancellations.reference }}
                  </div>
                </div>
              </td>
              <td style="width: 250px;">
                <div style="color: #6E6E6E">
                  <div>
                    <strong>Cobrança</strong>
                  </div>
                  <div style="display: flex;">
                    <div>
                      {{ cancellations.chargeStatus ? cancellations.chargeStatus : 'Sem status' }}
                    </div>
                    <div>
                      <i class="fa fa-pencil" v-b-modal.modal-update-charge @click="getCancellationChargeStatus(cancellations.chargeStatusId)" style="font-size: 15px; cursor: pointer; color: #313a70; margin-left: 5px;"></i>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-button variant="success" style="margin-top: 20px;" v-b-modal.modal-add-cancellations>Adicionar cancelamento</b-button>

      <b-modal
        id="modal-add-cancellations"
        ref="modal"
        title="Adicionar cancelamento"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
        >
        <form ref="form"  @submit.stop.prevent="addCancellation">
            <input
              type="hidden"
              v-model="cancellationId"
            />
          <div class="row">
            <div class="col-sm">
              <b-form-group
                :state="dateFormalizationState"
                label="Data da formalização"
                label-for="dateFormalization-input"
                invalid-feedback="Data da formalização obrigatório"
              >
                <b-form-input
                  id="dateFormalization-input"
                  v-model="dateFormalization"
                  v-mask="'##/##/####'"
                  :state="dateFormalizationState"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                :state="cancellationTypeState"
                label="Tipo"
                label-for="type-input"
                invalid-feedback="Tipo obrigatório"
              >
                <b-form-select v-model="cancellationType" @change="setCancellationType(cancellationType)" :options="cancellationTypeOptions"
                :state="cancellationTypeState"
                required
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-form-group
                :state="cancellationAmountState"
                label="Valor de estorno(Fundo)"
                label-for="fundoRefund-input"
                invalid-feedback="Valor obrigatório"
              >
                <b-form-input
                  id="fundoRefund-input"
                  v-model="cancellationAmount"
                  :state="cancellationAmountState"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                :state="customerAmountState"
                label="Valor de estorno(Cliente)"
                label-for="customerRefund-input"
                invalid-feedback="Valor obrigatório"
              >
                <b-form-input
                  id="customerRefund-input"
                  v-model="customerAmount"
                  :state="customerAmountState"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-form-group
                :state="iofState"
                label="IOF"
                label-for="iof-input"
                invalid-feedback="IOF obrigatório"
              >
                <b-form-input
                  class="form-control"
                  id="iof-input"
                  v-model="iof"
                  :state="iofState"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                :state="dueDateState"
                label="Data de pagamento"
                label-for="dueDate-input"
                invalid-feedback="Data do pagamento obrigatório"
              >
                <b-form-input
                  id="dueDate-input"
                  v-model="dueDate"
                  v-mask="'##/##/####'"
                  :state="dueDateState"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-form-group
                :state="cancellationRefundState"
                label="Status estorno"
                label-for="cancellationRefund-input"
                invalid-feedback="Status estorno obrigatório"
              >
                <b-form-select v-model="cancellationRefund" :options="refundOptions"
                :state="cancellationRefundState"
                required
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="col-sm">
              <b-form-group
                :state="cancellationReasonState"
                label="Motivo cancelamento"
                label-for="cancellationReason-input"
                invalid-feedback="Motivo obrigatório"
              >
                <b-form-select v-model="cancellationReason" :options="cancellationReasonOptions"
                :state="cancellationReasonState"
                required
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <b-form-group
            :state="cancellationStatusState"
            label="Status cancelamento"
            label-for="cancellationStatus-input"
            invalid-feedback="Status obrigatório"
          >
            <b-form-select v-model="cancellationStatus" :options="cancellationStatusOptions"
            :state="cancellationStatusState"
            required
            ></b-form-select>
          </b-form-group>
        </form>
      </b-modal>

      <table class="table table-responsive table-responsive-md" style="margin-top: 20px; color: #6E6E6E">
        <tbody>
          <tr class="d-flex" v-for="tc in cancellations.transactionCancellations" v-bind:key="tc.id">
            <td class="col-2">
              <div class="mt-3">
                <i class="fa fa-trash" @click="removeCancellation(tc.id)" style="font-size: 20px; cursor: pointer; color: #313a70;"></i>
                <i class="fa fa-pencil" v-b-modal.modal-add-cancellations @click="getTransactionCancellation(tc.id)" style="font-size: 20px; cursor: pointer; color: #313a70; margin-left: 10px;"></i>
                <i class="fa fa-link" v-if=tc.asanaLink @click="openAsana(tc.asanaLink)" style="font-size: 20px; cursor: pointer; color: #313a70; margin-left: 10px;"></i>
              </div>
            </td>
            <td class="col-2">
              <div class="subtitle">
                <strong>Data formalização</strong>
              </div>
              <div class="mt-3">
                {{ tc.dateFormalization | moment-date }}
              </div>
            </td>
            <td class="col-1">
              <div class="subtitle">
                <strong>Tipo</strong>
              </div>
              <div class="mt-3">
                {{ tc.cancellationType }}
              </div>
            </td>
            <td class="col-2">
              <div class="subtitle">
                <strong>Valor estorno(Fundo)</strong>
              </div>
              <div class="mt-3">
                {{ tc.cancellationAmount | numeral("$ 0,0.00") }}
              </div>
            </td>
            <td class="col-3">
              <div class="subtitle">
                <strong>Valor estorno(Cliente)</strong>
              </div>
              <div class="mt-3">
                {{ tc.customerAmount | numeral("$ 0,0.00") }}
              </div>
            </td>
            <td class="col-1">
              <div class="subtitle">
                <strong>IOF</strong>
              </div>
              <div class="mt-3">
                {{ tc.iof  | numeral("$ 0,0.00")}}
              </div>
            </td>
            <td class="col-3">
              <div class="subtitle">
                <strong>Data pagamento</strong>
              </div>
              <div class="mt-3">
                {{ tc.dueDate | moment-date }}
              </div>
            </td>
            <td class="col-3">
              <div class="subtitle">
                <strong>Status estorno</strong>
              </div>
              <div class="mt-3">
                {{ tc.cancellationRefund }}
              </div>
            </td>
            <td class="col-3">
              <div class="subtitle">
                <strong>Motivo cancelamento</strong>
              </div>
              <div class="mt-3">
                {{ tc.cancellationReason }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- MODAL UPDATE CHARGE STATUS -->
    <b-modal
      id="modal-update-charge"
      ref="modalChargeStatus"
      title="Status cobrança"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleUpdateChargeStatusOk"
    >
      <form ref="formChargeStatus" @submit.stop.prevent="handleUpdateChargeStatus">
        <b-form-group
          label="Status cobrança"
          label-for="charge-status-input"
        >
          <b-form-select v-model="cancellationChargeStatus" :options="cancellationChargeStatusOptions"
            ></b-form-select>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  data () {
    return {
      cancellations: null,

      cancellationId: null,
      cancellationAmount: null,
      cancellationStatus: null,
      cancellationStatusOptions: [
        { value: null, text: 'Selecione uma opção' },
        { value: 'FLAGGED', text: 'Sinalizado' },
        { value: 'FORMALIZED', text: 'Formalizado' },
        { value: 'ACCOMPLISHED', text: 'Realizado' }
      ],
      dateFormalization: null,
      dueDate: null,
      iof: null,
      cancellationRefund: null,
      refundOptions: [
        { value: null, text: 'Selecione uma opção' },
        { value: 'REFUND_RECEIVED', text: 'Recebido' },
        { value: 'REFUND_PENDING', text: 'Pendente' }
      ],
      customerAmount: null,
      cancellationChargeStatusId: null,
      cancellationChargeStatus: null,
      cancellationChargeStatusOptions: [
        { value: null, text: 'Selecione uma opção' },
        { value: 'ACTIVE', text: 'Ativa' },
        { value: 'SUSPENDED', text: 'Suspensa' },
        { value: 'FINISHED', text: 'Finalizada' }
      ],
      cancellationReason: null,
      cancellationReasonOptions: [
        { value: null, text: 'Selecione uma opção' },
        { value: 'DEFECT', text: 'Defeito' },
        { value: 'LEAVE', text: 'Desistência' },
        { value: 'ERROR_MISCARRIAGE_SINISTER', text: 'Erro/Extravio/Sinistro' },
        { value: 'TAXES', text: 'Juros ou ref. BoletoFlex' },
        { value: 'NOT_INFORMED', text: 'Não Informado' },
        { value: 'STORE_ISSUES', text: 'Outros Problemas c/ Loja' },
        { value: 'DELIVERY_TIME', text: 'Prazo de Entrega' }
      ],
      cancellationType: null,
      cancellationTypeOptions: [
        { value: null, text: 'Selecione uma opção' },
        { value: 'PARTIAL', text: 'PARCIAL' },
        { value: 'TOTAL', text: 'TOTAL' }
      ],
      dateFormalizationState: null,
      cancellationTypeState: null,
      cancellationAmountState: null,
      customerAmountState: null,
      iofState: null,
      dueDateState: null,
      cancellationRefundState: null,
      cancellationReasonState: null,
      cancellationStatusState: null,
      diagnostic: null
    }
  },
  mounted () {
    this.getCancellations()
  },
  methods: {
    handleUpdateChargeStatusOk (e) {
      e.preventDefault()

      this.handleUpdateChargeStatus()
    },
    handleUpdateChargeStatus () {
      if (this.cancellationChargeStatus) {
        this.$http.put(`api/cancellationChargeStatus/${this.cancellationChargeStatusId}`, {
          cancellationChargeStatus: this.cancellationChargeStatus
        })
          .then(function (res) {
            this.$bvToast.toast('Status atualizado com sucesso', {
              autoHideDelay: 5000,
              variant: 'success'
            })
            this.getCancellations()
            this.cancellationChargeStatusId = null
          })
          .catch(function (res) {
            console.log('Error')
            console.log(res)
            this.$bvToast.toast('Ocorreu um erro', {
              autoHideDelay: 5000,
              variant: 'danger'
            })
          })

        this.$nextTick(() => {
          this.$bvModal.hide('modal-update-charge')
        })
      }
    },
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.dateFormalizationState = valid
      this.cancellationTypeState = valid
      this.cancellationAmountState = valid
      this.customerAmountState = valid
      this.iofState = valid
      this.dueDateState = valid
      this.cancellationRefundState = valid
      this.cancellationReasonState = valid
      this.cancellationStatusState = valid
      return valid
    },
    resetModal () {
      this.cancellationId = null
      this.dateFormalization = null
      this.cancellationId = null
      this.cancellationType = null
      this.cancellationAmount = null
      this.cancellationStatus = null
      this.cancellationReason = null
      this.dueDate = null
      this.iof = null
      this.cancellationRefund = null
      this.customerAmount = null
      this.cancellationChargeStatusId = null
      this.cancellationChargeStatus = null

      this.dateFormalizationState = null
      this.cancellationTypeState = null
      this.cancellationAmountState = null
      this.customerAmountState = null
      this.iofState = null
      this.dueDateState = null
      this.cancellationRefundState = null
      this.cancellationReasonState = null
      this.cancellationStatusState = null

      this.getDiagnostic()
    },
    handleOk (e) {
      e.preventDefault()
      this.addCancellation()
    },
    addCancellation () {
      if (!this.checkFormValidity()) {
        return
      }
      if (!this.isValid()) {
        return
      }
      this.$http.post(`api/cancellations`, {
        id: this.cancellationId,
        transaction: this.$route.params.transactionId,
        cancellationType: this.cancellationType,
        cancellationAmount: parseFloat(this.cancellationAmount.toString().replace(',', '.')),
        cancellationStatus: this.cancellationStatus,
        cancellationReason: this.cancellationReason,
        dateFormalization: this.formatStringDate(this.dateFormalization),
        dueDate: this.formatStringDate(this.dueDate),
        iof: parseFloat(this.iof.toString().replace(',', '.')),
        cancellationRefund: this.cancellationRefund,
        customerAmount: parseFloat(this.customerAmount.toString().replace(',', '.'))
      })
        .then(function (res) {
          this.$bvToast.toast('Cancelamento adicionado/alterado com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
          this.getCancellations()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast('Ocorreu um erro', {
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })

      this.$nextTick(() => {
        this.$bvModal.hide('modal-add-cancellations')
      })
    },
    removeCancellation (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir o cancelamento ?', {
        title: 'Mensagem de confirmação',
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            this.$http.delete('api/cancellations/' + id)
              .then(function (res) {
                this.$bvToast.toast('Cancelamento excluído com sucesso', {
                  autoHideDelay: 5000,
                  variant: 'success'
                })
                this.getCancellations()
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCancellationChargeStatus (id) {
      this.$http.get('api/cancellationChargeStatus/' + id)
        .then(function (res) {
          this.cancellationChargeStatusId = res.data.id
          this.cancellationChargeStatus = res.data.status
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getTransactionCancellation (id) {
      this.$http.get('api/cancellation/' + id)
        .then(function (res) {
          this.cancellationId = res.data.id
          this.customerAmount = res.data.customerAmount
          this.cancellationReason = res.data.cancellationReason
          this.iof = res.data.iof
          this.cancellationRefund = res.data.cancellationRefund
          this.cancellationAmount = res.data.cancellationAmount
          this.dateFormalization = moment(res.data.dateFormalization).format('DD/MM/YYYY')
          this.dueDate = moment(res.data.dueDate).format('DD/MM/YYYY')
          this.cancellationStatus = res.data.cancellationStatus
          this.cancellationType = res.data.cancellationType
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getCancellations () {
      this.$http.get('api/cancellations/' + this.$route.params.transactionId)
        .then(function (res) {
          this.cancellations = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    isValid () {
      let ret = true
      if (this.diagnostic.openQuotes === 0) {
        ret = false
        this.$bvToast.toast('Pedido não possui parcelas pendentes, não é possível cancelar', {
          autoHideDelay: 5000,
          variant: 'danger'
        })
      }
      return ret
    },
    openAsana (url) {
      window.open(url, '_blank')
    },
    setCancellationType (type) {
      if (type === 'TOTAL') {
        this.calculateValues()
      } else {
        if (this.iof !== undefined) {
          this.iof = undefined
        }
        if (this.cancellationAmount !== null) {
          this.cancellationAmount = undefined
        }
        if (this.customerAmount !== null) {
          this.customerAmount = undefined
        }
      }
    },
    calculateValues () {
      this.iof = this.diagnostic.iof.toString().replace('.', ',')
      this.customerAmount = this.diagnostic.customerCancelledAmount.toString().replace('.', ',')
      this.cancellationAmount = (((parseFloat(this.cancellations.amount) - parseFloat(this.diagnostic.customerCancelledAmount)) - parseFloat(this.diagnostic.cancelledAmount)) + parseFloat(this.iof)).toString().replace('.', ',')
    },
    getDiagnostic () {
      this.$http.get('api/cancellations/diagnostic/' + this.$route.params.transactionId)
        .then(function (res) {
          this.diagnostic = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    formatStringDate (date) {
      var day = date.split('/')[0]
      var month = date.split('/')[1]
      var year = date.split('/')[2]

      return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2)
    }
  },
  watch: {
    '$route.params.transactionId' () {
      this.getCancellations()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/cancellations/CancellationsInfo.vue